'use strict';
/* jshint ignore:start */
var impressions = {

	// variables used by this module
	pageName: '',
	lastImpressions: {},
	lastImpressionList: '',

	// keep record of latest list used for interaction
	// use product name and SKU as keys as most applicable for search
	trackLastImpression: function(impressionObj) {
		var recordedImpressions = impressions.lastImpressions[impressionObj.impression_list] || '';
		if (recordedImpressions.indexOf(impressionObj.impression_product_SKU) < 0) {
			recordedImpressions += ', ' + impressionObj.impression_product_SKU;
		}
		if (recordedImpressions.indexOf(impressionObj.impression_product_name) < 0) {
			recordedImpressions += ', ' + impressionObj.impression_product_name;
		}
		// limit for storage purposes, make sure it is size cut
		var extraSize = recordedImpressions.length - 1999;
		if (extraSize > 0) {
			var position = recordedImpressions.indexOf(', ', extraSize);
			recordedImpressions = recordedImpressions.substring(position > 0 ? position : extraSize);
		}

		impressions.lastImpressionList = impressionObj.impression_list;
		impressions.lastImpressions[impressionObj.impression_list] = recordedImpressions;
		storeData();
	},
	// retrive impression list applicable for that product or latest one available
	getLastImpressionList: function(productID, productName) {
		reStoreData();
		for (var listName in impressions.lastImpressions) {
			var impressionKeys = impressions.lastImpressions[listName];
			if ((productID && impressionKeys.indexOf(productID) > 0) || (productName && impressionKeys.indexOf(productName) > 0)) {
				return listName;
			}
		}
		return impressions.lastImpressionList || impressions.getPageName();
	},

	/*
		Shared method to get page name for tracking
	*/
	getPageName: function() {
		if (this.pageName) {
			return this.pageName;
		}
		this.pageName = window.pageContext && window.pageContext.title ? window.pageContext.title : 'OTHER';
		this.pageName = this.pageName.trim().replace(/[^0-9a-z \-\|]/gi, '');
		try {
			var pageDataInput = $(document).find('input[name="pageLoadData"]');
			if (!pageDataInput.length) {
				return impressions.pageName;
			}
			var pageLoadData = JSON.parse(pageDataInput.val());
			this.pageName = pageLoadData.page_name || this.pageName;
			this.pageName = this.pageName.trim().replace(/[^0-9a-z \-\|]/gi, '');
		} catch(e) {
			console.warn(e);
		}
		return this.pageName;
	},
	/*
		Method to get product impression data fron content tile
		some carousel are not related to products and should be filtered here
		no object returned in such case
	*/
	getProductImpressionFromContent: function($contentTile) {
		var productImpression = {};
		try {
			var $productLink = $contentTile.find('a');
			var $headingContent = $contentTile.find('.heading');
			// it's a lot to check, so we rely on try/catch mostly in this section
			if (!$productLink.length || !$headingContent.length) {
				return;
			}
			var productSKU = $productLink.attr('href').split('pid=')[1];
			var listType = $contentTile.closest('[impression-list-type]').attr('impression-list-type');
			var itemIndex = $contentTile.attr('impression-position');
			if (!productSKU || !listType || !itemIndex) {
				window.console.debug('tile without product', productSKU, listType, itemIndex);
				return;
			}

			var headingContentParts = $headingContent.text().split(window.Resources.CURRENCY_SYMBOL);
			var productName = headingContentParts[0].trim();
			var productPrice = headingContentParts[1].replace(/\D.\D+\D+/g, '').trim();
	
			productImpression['impression_position'] = itemIndex;
			productImpression['impression_price'] = productPrice;
			productImpression['impression_product_SKU'] = productSKU;
			productImpression['impression_product_brand'] = 'Hotel Chocolat';
			productImpression['impression_product_category'] = 'No Category Available (Carousel Impression)';
			productImpression['impression_product_name'] = productName;
			productImpression['impression_product_variant'] = productName;
			productImpression['impression_list'] = listType + ' - ' + impressions.getPageName();
		} catch (e) {
			// do not return object in case of error, to avoid another iteration
			window.console.warn(e);
			return;
		}
		
		return productImpression;
	},
	/*
		Method to get product impression data fron product tile
		if any of required markers missing it will return null
	*/
	getProductImpressionFromTile: function ($productTile) {
		var productImpression = {};
		try {
			var $impressionInput = $productTile.find('input[name=productImpression]');
			var listType = $productTile.closest('[impression-list-type]').attr('impression-list-type');
			var itemIndex = $productTile.attr('impression-position');
			if (!$impressionInput.length || !listType || !itemIndex) {
				return;
			}
			// to get listing, we need to know type of container and related item index
			var impressionData = JSON.parse($impressionInput.val());
			productImpression['impression_position'] = itemIndex;
			productImpression['impression_price'] = impressionData.impression_price;
			productImpression['impression_product_SKU'] = impressionData.impression_product_SKU;
			productImpression['impression_product_brand'] = impressionData.impression_product_brand;
			productImpression['impression_product_category'] =impressionData.impression_product_category;
			productImpression['impression_product_name'] = impressionData.impression_product_name;
			productImpression['impression_product_variant'] = impressionData.impression_product_variant;
			productImpression['impression_list'] = listType + ' - ' + impressions.getPageName();
		} catch (e) {
			// do not return object in case of error, to avoid another iteration
			window.console.warn(e);
			return;
		}

		return productImpression;
	},

	/*
		Enable method to get content from the product tile of different format
		return null if tile not related to product
	*/
	getProductImpression: function ($productTile) {
		var productImpression = $productTile.data('impressionObj');
		if (productImpression) {
			return productImpression['impression_product_SKU'] ? productImpression : null;
		}
		// collect object and update storage for further use
		productImpression = this.getProductImpressionFromTile($productTile) || this.getProductImpressionFromContent($productTile);
		$productTile.data('impressionObj', productImpression || {});
		return productImpression;
	},

	promoBannerImpression: function () {
		if ($('.banner-content').length > 0) {
			var obj = {
				'event': 'promoBannerImpression',
				'banner_creative': $('input[name=bannerCreative]').val() ? $('input[name=bannerCreative]').val() : '',
				'banner_position': $('input[name=bannerPosition]').val() ? $('input[name=bannerPosition]').val() : ''
			};
			dataLayer.push(obj);
		}
	},
	
	/*
		impressions tracking consolidated here
		specific containers present on page, each of them should be reported individually
		container could be updated - means tile inside it would be in different position or with different content
		that means tile would hold state of being reported, likely container update would reset all insides but leave it unchaged
		
		currently we have 3 types of containers:
		- carousels build via content (slick or no slick items) 
		- carousels build via code (einstain or basic)
		- search results page - common tiles
		- PDP components also
		
		that means in every case we have tile
		if that is code based it would include ('input[name=productImpression]')
		otherwise we could treat as content based and attempt parsing
		item position based on tile location inside container
		
		in case of search results requirment to keep impressions reported limited to 24
		but actual hard limit is about 50, 
	*/
	trackImpressions: function () {
		// identify all impression containers and flag their type
		// first type is search page container
		var $impressionContainers = $('.search-result-content, .search-result-items');
		$impressionContainers.each(function () {
			$(this).attr('impression-list-type', 'PLP');
		});

		// next is einstain carousels
		$impressionContainers = $('.content-tiles-slider-container-deferred, .recommendations.recommendations-pdp');
		$impressionContainers.each(function (carouselIndex) {
			$(this).attr('impression-list-type', 'EIN - ' + (carouselIndex + 1));
		});
		
		// other carousels, content or slot based and product components on PDP
		$impressionContainers = $('.tiles-container, .component-content, .content-tiles-slider-container').filter(':not([impression-list-type])');
		$impressionContainers.each(function (carouselIndex) {
			$(this).attr('impression-list-type', 'CAR - ' + (carouselIndex + 1));
		});

		// now grab all containers and triggger impressions reporting
		$impressionContainers = $('[impression-list-type]');
		$impressionContainers.each(function () {
			// selector build based on site tiles, can be extended to cover more cases, but need to carefully consider tree to avoid duplicates
			var $productTiles = $(this).find('.content-tile-wrapper, .content-tile.slick-slide, .recommendation-item .product-tile, .grid-tile, .product-component-item');
			var productImpressions = [];
			// include impressions that are not collected yet, updating visibility
			$productTiles.each(function(itemIndex, productTile) {
				var $productTile = $(productTile);
				// filtering done here to keep positions accurate if more tiles added
				if ($productTile.attr('impression-seen')) {
					return;
				}
				$productTile.attr('impression-position', itemIndex + 1);
				$productTile.attr('impression-seen', '0');
				var productImpression = impressions.getProductImpression($productTile);
				if (productImpression) {
					$productTile.attr('impression-seen', '1');
					productImpressions.push(productImpression);
				}
			});

			// handle reporting limit
			const impressionsLimit = 24;
			for (var i = 0, reportBatch; i < productImpressions.length; i += impressionsLimit) {
				reportBatch = productImpressions.slice(i, i + impressionsLimit);
				if (reportBatch.length) {
					dataLayer.push({
						'event': 'productImpressionTracking',
						'button_ID': '',
						'impressions': reportBatch
					});
				}
			}
		});
		
		// attach global event using selector targeting seen impressions, that makes sure they are valid
		$(document).off('click.impression').on('click.impression', '[impression-seen="1"]', impressions.productClickTrackingEvent);
		$(document).off('click.noimpression').on('click.noimpression', '[impression-seen="0"]', impressions.productClickResetEvent);
	},

	// event handler for click on carousel item
	productClickTrackingEvent: function (e) {
		var $this = $(this);
		var productImpression = impressions.getProductImpression($this);
		if (!productImpression || !productImpression['impression_product_SKU']) {
			return;
		}
		var obj = {
			'event': 'productClickTracking',
			'button_ID': ''
		};
		$.extend(obj, productImpression);
		dataLayer.push(obj);

		impressions.trackLastImpression(obj);
	},

	// handle click on tiles that do not have valid impressions
	// force page name to be reported
	productClickResetEvent: function () {
		impressions.lastImpressionList = impressions.getPageName();
	}
};

/*
	Methods to pass data betwean pages
*/
function reStoreData() {
	if (!impressions.lastImpressionList) {
		impressions.lastImpressionList = window.localStorage.getItem('lastImpressionList');
	}
}

function storeData() {
	window.localStorage.setItem('lastImpressionList', impressions.lastImpressionList);
}

module.exports = impressions;
/* jshint ignore:end */
